import React from 'react';
import clsx from 'clsx';
import i18n from 'i18next';
import SimpleLoader from '../loaders/SimpleLoader';

interface StatusIndicator {
  variant: 'RUNNING' | 'STOPPED' | 'FAILED' | 'CONFIGURING';
  text?: string;
}

const StatusBadge = (props: StatusIndicator) => {
  let colorClass;
  switch (props.variant) {
    case 'FAILED':
      colorClass = 'badge-danger';
      break;
    case 'STOPPED':
      colorClass = 'badge-secondary';
      break;
    case 'RUNNING':
      colorClass = 'badge-success';
      break;
  }

  //Configuring Badge
  if (props.variant === 'CONFIGURING') {
    return (
      <span
        className="badge badge-warning badge-pill align-middle"
        title={i18n.t('mockServices:mockServicesTable.statusMsg.pleaseWait')}
      >
        <SimpleLoader loaderSize={15} style={{ display: 'inline-block', marginRight: '4px' }} showLoadingText={false} />
        {'Configuring'}
      </span>
    );
  }

  return <span>{props.text && <span className={clsx(colorClass, 'badge badge-pill')}>{props.text}</span>}</span>;
};

export default StatusBadge;
